
import React from 'react';
import { Alert, Button, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, LogOut } from 'lucide-react';

import { logAuth } from '@/lib/breadcrumbs';

interface CustomerErrorStateProps {
  error: string;
  onLogout: () => void;
  showLogoutButton?: boolean;
}

const CustomerErrorState: React.FC<CustomerErrorStateProps> = ({
  error,
  onLogout,
  showLogoutButton = true
}) => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 448, display: 'flex', flexDirection: 'column', gap: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <AlertTriangle size={48} style={{ color: 'var(--mantine-color-red-6)' }} />
        </div>

        <Title order={2} ta="center">Authentication Error</Title>

        <Alert color="red">
          <Title order={5} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <AlertTriangle size={16} />
            Error
          </Title>
          <Text size="sm" mt="xs">
            {error}
          </Text>
        </Alert>

        {showLogoutButton ? (
          <Button
            variant="outline"
            fullWidth
            mt="md"
            onClick={onLogout}
            leftSection={<LogOut size={16} />}
          >
            Logout
          </Button>
        ) : (
          <Button
            variant="filled"
            fullWidth
            mt="md"
            onClick={() => navigate('/login')}
          >
            Return to Login
          </Button>
        )}
      </div>
    </div>
  );
};

export default CustomerErrorState;
